import toast from '../SnackDom';
import { getDashboard, dashboardActions } from '../../redux/slices/dashboard';
import { getOnlineUsers, UpdateChats, RemoveChats } from '../../redux/slices/online';
import { updatePabxState } from '../../redux/slices/pabx';
import { PATH_DASHBOARD } from '../../routes/paths';

const SERVICE_STATUS = {
  CONNECTED: 'connected',
  AUTH_ERROR: 'auth_error',
  CONNECTION_WARNING: 'connection_warning',
};

const serviceStatusAlertCache = new Map();

export class AdminHandlers {
  static async handleWhatsAppQrCode(message, user) {
    const service = user?.services?.find((e) => e._id === message.metadata?.serviceId);

    if (service && message.data?.whatsApp?.qrCode) {
      toast.callqrcode(service.description, message.data.whatsApp.qrCode);
    }
  }

  static async handleServiceStatusUpdate(message, user) {
    const service = user?.services?.find((e) => e._id === message.metadata?.serviceId);
    if (!service) return;

    try {
      const { authenticated, connected, launched } = message.data || {};
      const statusKey = AdminHandlers.getServiceStatusKey({ authenticated, connected, launched });
      const cacheKey = message.metadata?.serviceId || service._id;

      if (!statusKey) {
        serviceStatusAlertCache.delete(cacheKey);
        return;
      }

      if (serviceStatusAlertCache.get(cacheKey) === statusKey) {
        return;
      }
      serviceStatusAlertCache.set(cacheKey, statusKey);

      if (statusKey === SERVICE_STATUS.CONNECTED) {
        toast.success(`Tronco ${service.description} conectado com sucesso!`, 1);
      } else if (statusKey === SERVICE_STATUS.AUTH_ERROR) {
        toast.error(`Tronco ${service.description} desconectado ou com falha na autenticação!`, 1);
      } else if (statusKey === SERVICE_STATUS.CONNECTION_WARNING) {
        toast.warn(`Tronco ${service.description} com problemas de conexão!`, 1);
      }
    } catch (error) {
      console.error('Erro ao processar serviceStatusUpdate:', error);
      toast.error('Erro ao atualizar informações de tronco.', 1);
    }
  }

  static getServiceStatusKey({ authenticated, connected, launched }) {
    if (authenticated && connected) {
      return SERVICE_STATUS.CONNECTED;
    }
    if (launched && !connected && !authenticated) {
      return SERVICE_STATUS.AUTH_ERROR;
    }
    if (launched && !connected) {
      return SERVICE_STATUS.CONNECTION_WARNING;
    }
    return null;
  }

  static handleUserEvents(dispatch, user) {
    if (window.location.pathname.includes(PATH_DASHBOARD.general.app) && user.companyId) {
      dispatch(getDashboard(user.companyId));
    }
    if (window.location.pathname.includes(PATH_DASHBOARD.online.root)) {
      dispatch(getOnlineUsers());
    }
  }

  static handleDashboardUpdate(dispatch, message) {
    dispatch(dashboardActions.getDashboardSuccess(message.data));
  }

  static handleChatAssignmentAdmin(dispatch, message) {
    if (window.location.pathname.includes(PATH_DASHBOARD.online.root) && message.data) {
      dispatch(UpdateChats(message.data));
    }
  }

  static handleChatTransferAdmin(dispatch, message) {
    if (window.location.pathname.includes(PATH_DASHBOARD.online.root) && message.data) {
      dispatch(UpdateChats(message.data));
    }
  }

  static handleChatFinalizationAdmin(dispatch, message) {
    if (!message.data?.chatId) {
      console.error('Socket event "chatFinalization" sem chatId:', message.data);
      return;
    }

    if (window.location.pathname.includes(PATH_DASHBOARD.online.root) && message.data) {
      dispatch(RemoveChats(message.data));
    }
  }

  static handlePabxStateUpdate(dispatch, message) {
    if (!message.data) return;

    const { sips = [], queues = [], agents = [] } = message.data;
    dispatch(updatePabxState({ sips, queues, agents }));
  }
}
